import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import CONSTANTS from "./CONSTANTS";
import actions from "./actions";
import { toast } from "react-toastify";

const baseUrl = "/services/rcp/cl/content/";
const blogsUrl = "/services/rcp/cl/blogs/";

export function* getBanners() {
  yield takeLatest(CONSTANTS.GET_MAIN_PAGE_BANNERS, function* () {
    try {
      yield put(actions.setBanners(null));
      const lang = yield select((state) => state.common.lang);
      const btnTextOne = lang === "ge" ? "მიწერე ბოტს" : "contact bot";
      const btnTextTwo = lang === "ge" ? "გაიგე მეტი" : "learn more";

      const data = [
        {
          inContentType: 0,
          //   files: {
          //     desktopFile: "/assets/static/images/main-profile-banner.png",
          //     mobileFile: "",
          //   },
          headerName: "",
          // lang === "ge" ? (
          //   <>
          //     <p>
          //       ვებგვერდზე ხელმისაწვდომია ანაზღაურების, დისტანციური
          //       მიმართვებისა და ჰოსპიტალური გარანტიების სერვისი.
          //     </p>
          //     <p>
          //       ჩვენი გუნდი 24 საათიან რეჟიმში მუშაობს, რათა კიბერ შეტევით
          //       გამოწვეული ტექნიკური ხარვეზები აღმოვფხვრათ და შეფერხებების
          //       გარეშე გავაგრძელოთ მომხმარებლების მომსახურება.
          //     </p>
          //     <p>მადლობა თანამშრომლობისთვის.</p>
          //   </>
          // ) : (
          //   <>
          //     <p className="ms-xl-5">
          //       Reimbursement, remote referrals and inpatient guarantee
          //       services are all available on our website.
          //     </p>
          //     <p className="ms-xl-5 pt-3">
          //       Our team is working 24/7 to ensure uninterrupted service,
          //       caused by a cyber security.
          //     </p>
          //     <p className="ms-xl-5">Thank you for cooperation.</p>
          //   </>
          // ),
          textName: "",
          showButton: false,
          buttonUrl: "",
          buttonText: btnTextOne,
        },
        {
          inContentType: 1,
          //   files: {
          //     desktopFile: "/assets/static/images/travel-photo.png",
          //     mobileFile: "",
          //   },
          headerName:
            lang === "ge" ? "სამოგზაურო დაზღვევა" : "Travel Insurance",
          textName:
            lang === "ge" ? (
              <p>
                თუ ნანატრი მოგზაურობა უკვე დაგეგმე, იმედი L-ის სამოგზაურო
                დაზღვევა საშუალებას გაძლევს თავი დაცულად იგრძნო ქვეყნის ფარგლებს
                გარეთ.
              </p>
            ) : (
              <p>
                If you have already planned your long-awaited trip, ImediL
                travel insurance allows you to feel safe abroad.
              </p>
            ),
          showButton: true,
          buttonUrl: "",
          buttonText: btnTextTwo,
        },
      ];
      // const url = baseUrl + "GetBanners";
      // const res = yield window.mainAxios.get(url).then(r => r.data);
      // // console.log(res)
      // // eslint-disable-next-line no-throw-literal
      // if (!res.success) throw {
      //     errorCode: res.errorCode,
      //     errorMessage: res.errorMessage
      // }

      // const data = res.data;

      yield put(actions.setBanners(data));
    } catch (e) {
      yield put(actions.setBanners([]));
      console.error(e);
    }
  });
}

export function* getNewsAndBlogsForClientLatest() {
  yield takeLatest(CONSTANTS.GET_MAIN_PAGE_NEWS_AND_BLOGS, function* () {
    try {
      yield put(actions.setGlobalPageLoader(true));
      yield put(actions.setNewsAndBlogsForClientLatest(null));

      const url = blogsUrl + "GetNewsAndBlogsForClientLatest";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setNewsAndBlogsForClientLatest(data));
    } catch (e) {
      yield put(actions.setNewsAndBlogsForClientLatest([]));
      console.error(e);
    } finally {
      yield put(actions.setGlobalPageLoader(false));
    }
  });
}

export function* getNewsAndBlogsForClientById() {
  yield takeLatest(
    CONSTANTS.GET_NEWS_AND_BLOGS_DETAILD_DATA,
    function* (action) {
      try {
        yield put(actions.setGlobalPageLoader(true));
        yield put(actions.setNewsAndBlogsForClientById({}));

        const url =
          blogsUrl +
          "GetNewsAndBlogsForClientById?newsAndBlogsId=" +
          action?.payload;
        const res = yield window.mainAxios.get(url).then((x) => x.data);

        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        yield put(actions.setNewsAndBlogsForClientById(res.data));
      } catch (e) {
        yield put(actions.setNewsAndBlogsForClientById({}));
        toast.error("ბლოგების წამოღება ვერ მოხერხდა");
      } finally {
        yield put(actions.setGlobalPageLoader(false));
      }
    }
  );
}

// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(getBanners),
    fork(getNewsAndBlogsForClientLatest),
    fork(getNewsAndBlogsForClientById),
  ]);
}
